import script from "./PersonsRehabilitated.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonsRehabilitated.vue?vue&type=script&setup=true&lang=ts"

import "./PersonsRehabilitated.vue?vue&type=style&index=0&id=70e236dc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e236dc"]])

export default __exports__